<template>
    <section class="container">
        <div class="flex items-center justify-between">
            <AtomTitle> {{ title }} </AtomTitle>
            <div class="hidden gap-3 md:flex">
                <ArrowButton
                    id="interesting-prev"
                    class="rotate-180" />
                <ArrowButton id="interesting-next" />
            </div>
        </div>
        <div class="mt-5 block max-w-full">
            <div class="swiper swiper-interesting">
                <div class="swiper-wrapper">
                    <div
                        v-for="item in items"
                        :key="item.slug || item.object + item.id"
                        class="swiper-slide !h-auto max-md:!w-[17.5rem]">
                        <ProductLineInterestingSectionCard :item />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { Swiper } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import { Navigation } from 'swiper/modules'

import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import ArrowButton from '~/components/base/arrow-button/ArrowButton.vue'
import ProductLineInterestingSectionCard from '~/components/particles/product-line-interesting-section/ProductLineInterestingSectionCard.vue'
import type { InterestingSectionCard } from '~/components/particles/product-line-interesting-section/product-line-interesting-section.types'

defineProps({
    title: {
        type: String as PropType<string>,
        default: 'Также вас может заинтересовать',
    },
    items: {
        type: Array as PropType<InterestingSectionCard[]>,
        required: true,
    },
    catalogCategory: {
        type: [String, null] as PropType<string | null>,
        default: null,
    },
    directionSlug: {
        type: [String, null] as PropType<string | null>,
        default: null,
    },
})

onMounted(() => {
    new Swiper('.swiper-interesting', {
        modules: [Navigation],
        navigation: {
            prevEl: '#interesting-prev',
            nextEl: '#interesting-next',
        },
        slidesPerView: 'auto',
        spaceBetween: 8,
        breakpoints: {
            375: {
                slidesPerView: 'auto',
                spaceBetween: 20,
            },
            744: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
    })
})
</script>
